window.loadCountdown = (() => {
    let scriptLoadPromise = null;

    return function () {
        if (document.getElementById('countdown-script')) {
            return scriptLoadPromise || Promise.resolve();
        }

        scriptLoadPromise = new Promise((resolve, reject) => {
            const script = Object.assign(document.createElement('script'), {
                src: '/build/assets/static/countdown.js',
                id: 'countdown-script',
                onload: resolve,
                onerror: reject,
            });

            document.head.appendChild(script);
        });

        return scriptLoadPromise;
    };
})();

// units: countdown.js unit names joined with |, e.g. "DAYS|HOURS|MINUTES"
Alpine.data("countdownAlpine", (timestamp, units = 'MONTHS|WEEKS|DAYS|HOURS|MINUTES', max = NaN, digits = 0) => ({
    countdown: null,
    timer: null,

    init() {
        this.update();
        this.timer = setInterval(() => this.update(), 1000);
    },

    destroy() {
        clearInterval(this.timer);
    },

    update() {
        loadCountdown().then(() => {
            const flags = units.split('|').reduce((all, unit) => all | (countdown[unit] ?? 0), 0);

            this.countdown = countdown(new Date(timestamp * 1000), null, flags, max, digits);
        });
    },
}));
